import { useFormikContext } from "formik";

const useFormikError = (id: string) => {
  const { submitCount, getFieldMeta } = useFormikContext();
  // @ts-ignore - id is a string, TS cannot index an string in this case
  const meta = getFieldMeta(id);
  const errorMessage = submitCount > 0 || meta.touched ? meta.error : "";
  return errorMessage;
};

export default useFormikError;
